module.exports = __webpack_public_path__ + "static/media/Airplane Girl.fe82fb28.jpg";